/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';
import { IProductLinkData } from './product-link.data';
import { IProductLinkProps } from './product-link.props.autogenerated';

/**
 *
 * ProductLink component
 * @extends {React.PureComponent<IProductLinkProps<IProductLinkData>>}
 */
class ProductLink extends React.PureComponent<IProductLinkProps<IProductLinkData>> {
    public render(): JSX.Element {
        const { config, data } = this.props;
        let productUrl;
        if(data.product && data.product.status === 'SUCCESS') {
            const product = data.product.result;
            if(product) {
                productUrl = getProductUrlSync(product, this.props.context.actionContext, undefined);
            }
        }

        return (
            <div className='product-link'>
                {productUrl && <a className='product-link-cta' href={productUrl} aria-label={config.linkText} onClick={this._productLinkClick}>{config.linkText}</a>}
            </div>
        );
    }

    // tslint:disable-next-line: no-any
    private _productLinkClick = (e: any):void => {
        if(window.location !== window.parent.location && e && e.currentTarget && e.currentTarget.href) {
            window.parent.location.href = e.currentTarget.href;
        }

        return;
    };
}

export default ProductLink;